export default function Concept() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="conceito" className="bg-white py-32">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          {/* Left Column - 40% */}
          <div className="lg:col-span-2">
            <p className="text-gray-500 text-sm uppercase tracking-wider mb-4">(POR QUE O ATMOS)</p>
            <h2 className="font-serif font-bold text-5xl lg:text-6xl text-black leading-tight">
              O Primeiro da <span className="text-gray-400">Linha VOLT</span>
            </h2>
          </div>

          {/* Right Column - 60% */}
          <div className="lg:col-span-3">
            <div className="space-y-6 text-gray-700 text-base lg:text-lg leading-relaxed">
              <p>
                O <strong>ATMOS</strong> é o primeiro empreendimento da nova linha de estúdios da ATR 
                chamada <strong>VOLT</strong>, desenvolvido em parceria com a <strong>HOUSI</strong>. 
                Uma proposta inovadora que une design contemporâneo, funcionalidade e localização estratégica.
              </p>
              <p>
                Situado na <strong>Av. Visconde de Guarapuava, 2807</strong>, no coração do Centro de Curitiba, 
                o empreendimento oferece acesso direto à Av. Sete de Setembro e Av. Marechal Floriano Peixoto, 
                estando a apenas 7 quadras do Batel. Uma localização privilegiada para quem valoriza mobilidade 
                e proximidade com tudo.
              </p>
              <p>
                Com <strong>326 unidades</strong> que incluem gardens com pé direito duplo, estúdios com pé direito 
                Plex e apartamentos de 1 e 2 quartos, o ATMOS atende diferentes perfis e necessidades. A integração 
                com o <strong>Appspace</strong> conecta o empreendimento a mais de 80 marcas e serviços, oferecendo 
                conveniência e experiências exclusivas.
              </p>
              <p>
                Aproveite a fase de venda antecipada com <strong>condições especiais da tabela zero</strong>. 
                Um empreendimento da <strong>ATR Incorporadora</strong> com entrega prevista para setembro de 2028.
              </p>
            </div>

            <a
              href="https://wa.me/5541988674555?text=Olá! Quero saber mais sobre o ATMOS e as condições especiais."
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center space-x-2 bg-black text-white px-8 py-4 rounded-full font-semibold hover:bg-gray-800 transition-all whitespace-nowrap cursor-pointer"
            >
              <span>Falar com Consultor</span>
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
